export default "__VITE_ASSET__C0Rri040__"